import itemAttributes from './itemDataAttributes';
import watchAttributes from './watchDataAttributes';
import carAttributes from './carDataAttributes';
import otherAttributes from './otherDataAttributes';
import comicAttributes from './comicDataAttributes';
import ArtAttributes from './artDataAttributes';
import AntiqueAttributes from './antiqueDataAttributes';
import BookAttributes from './bookDataAttributes';
import CameraAttributes from './cameraDataAttributes';
import FirearmAttributes from './firearmDataAttributes';
import HandbagAttributes from './handbagDataAttributes';
import JewelryAttributes from './jewelryDataAttributes';
import ToyAttributes from './toyDataAttributes';
import SportCardAttributes from './sportsCardDataAttributes';
import VinylRecordAttributes from './vinylRecordDataAttributes';
import CoinAttributes from './coinDataAttributes';
import StampAttributes from './stampDataAttributes';
import HistoricalMemAttributes from './historicalMemorabiliaDataAttributes';
import MovieMemAttributes from './movieMemorabiliaDataAttributes';
import MusicalInstrumentAttributes from './musicalInstrumentDataAttributes';
import MusicMemAttributes from './musicMemorabiliaDataAttributes';
import SportsMemAttributes from './sportsMemorabiliaDataAttributes';
import WineAttributes from './wineDataAttributes';

export const Attributes = {
  COMMON: itemAttributes,
  WATCH: watchAttributes,
  CAR: carAttributes,
  COMIC: comicAttributes,
  OTHER: otherAttributes,
  ANTIQUE: AntiqueAttributes,
  ART: ArtAttributes,
  BOOK: BookAttributes,
  COIN: CoinAttributes,
  STAMP: StampAttributes,
  CAMERA: CameraAttributes,
  FIREARM: FirearmAttributes,
  HANDBAG: HandbagAttributes,
  JEWELRY: JewelryAttributes,
  TOY: ToyAttributes,
  SPORTS_CARD: SportCardAttributes,
  VINYL_RECORD: VinylRecordAttributes,
  MUSICAL_MEM: MusicMemAttributes,
  SPORTS_MEM: SportsMemAttributes,
  HISTORIC_MEM: HistoricalMemAttributes,
  MOVIE_MEM: MovieMemAttributes,
  MUSICAL_INST: MusicalInstrumentAttributes,
  WINE: WineAttributes,
};

export const PossibleSplitAttrs = {
  WATCH: [
    ['w_brand', Attributes.WATCH.w_brand.friendly],
    ['w_model', Attributes.WATCH.w_model.friendly],
    ['w_movement', Attributes.WATCH.w_movement.friendly],
    ['w_case_material', Attributes.WATCH.w_case_material.friendly],
    ['w_year_produced', Attributes.WATCH.w_year_produced.friendly],
    ['w_country_of_origin', Attributes.WATCH.w_country_of_origin.friendly],
    ['w_diameter_mm', Attributes.WATCH.w_diameter_mm.friendly],
    ['w_dial_color', Attributes.WATCH.w_dial_color.friendly],
  ],

  CAR: [
    ['c_brand', Attributes.CAR.c_brand.friendly],
    ['c_year', Attributes.CAR.c_year.friendly],
    ['c_model', Attributes.CAR.c_model.friendly],
    ['c_origin_country', Attributes.CAR.c_origin_country.friendly],
  ],

  COMIC: [
    ['comic_series_group', Attributes.COMIC.comic_series_group.friendly],
    ['comic_series', Attributes.COMIC.comic_series.friendly],
    ['comic_publisher', Attributes.COMIC.comic_publisher.friendly],
    ['comic_era', Attributes.COMIC.comic_era.friendly],
    ['comic_country_of_origin', Attributes.COMIC.comic_country_of_origin.friendly],
  ],

  OTHER: [
    ['o_category', Attributes.OTHER.o_category.friendly],
    ['o_maker', Attributes.OTHER.o_maker.friendly],
    ['o_medium', Attributes.OTHER.o_medium.friendly],
    ['o_year_produced', Attributes.OTHER.o_year_produced.friendly],
  ],

  ANTIQUE: [
    ['ant_type', Attributes.ANTIQUE.ant_type.friendly],
    ['ant_maker', Attributes.ANTIQUE.ant_maker.friendly],
    ['ant_medium', Attributes.ANTIQUE.ant_medium.friendly],
    ['ant_year_produced', Attributes.ANTIQUE.ant_year_produced.friendly],
    ['ant_country_of_origin', Attributes.ANTIQUE.ant_country_of_origin.friendly],
  ],

  ART: [
    ['art_artist_name', Attributes.ART.art_artist_name.friendly],
    ['art_media', Attributes.ART.art_media.friendly],
    ['art_medium', Attributes.ART.art_medium.friendly],
    ['art_year_produced', Attributes.ART.art_year_produced.friendly],
    ['art_period', Attributes.ART.art_period.friendly],
    ['art_movement', Attributes.ART.art_movement.friendly],
    ['art_country_of_origin', Attributes.ART.art_country_of_origin.friendly],
  ],

  BOOK: [
    ['book_author_name', Attributes.BOOK.book_author_name.friendly],
    ['book_publisher', Attributes.BOOK.book_publisher.friendly],
    ['book_publication_date', Attributes.BOOK.book_publication_date.friendly],
    ['book_genre', Attributes.BOOK.book_genre.friendly],
    ['book_edition', Attributes.BOOK.book_edition.friendly],
    ['book_country', Attributes.BOOK.book_country.friendly],
  ],

  CAMERA: [
    ['camera_type', Attributes.CAMERA.camera_type.friendly],
    ['camera_manufacturer', Attributes.CAMERA.camera_manufacturer.friendly],
    ['camera_model', Attributes.CAMERA.camera_model.friendly],
    ['camera_year_produced', Attributes.CAMERA.camera_year_produced.friendly],
    ['camera_country_of_origin', Attributes.CAMERA.camera_country_of_origin.friendly],
  ],

  FIREARM: [
    ['firearm_type', Attributes.FIREARM.firearm_type.friendly],
    ['firearm_manufacturer', Attributes.FIREARM.firearm_manufacturer.friendly],
    ['firearm_model', Attributes.FIREARM.firearm_model.friendly],
    ['firearm_manufacturer_date', Attributes.FIREARM.firearm_manufacturer_date.friendly],
    ['firearm_caliber', Attributes.FIREARM.firearm_caliber.friendly],
    ['firearm_accessories', Attributes.FIREARM.firearm_accessories.friendly],
  ],

  HANDBAG: [
    ['handbag_type', Attributes.HANDBAG.handbag_type.friendly],
    ['handbag_brand', Attributes.HANDBAG.handbag_brand.friendly],
    ['handbag_collection', Attributes.HANDBAG.handbag_collection.friendly],
    ['handbag_model', Attributes.HANDBAG.handbag_model.friendly],
    ['handbag_color', Attributes.HANDBAG.handbag_color.friendly],
    ['handbag_material', Attributes.HANDBAG.handbag_material.friendly],
    ['handbag_year_produced', Attributes.HANDBAG.handbag_year_produced.friendly],
    ['handbag_country_of_origin', Attributes.HANDBAG.handbag_country_of_origin.friendly],
  ],

  JEWELRY: [
    ['jewelry_type', Attributes.JEWELRY.jewelry_type.friendly],
    ['jewelry_maker', Attributes.JEWELRY.jewelry_maker.friendly],
    ['jewelry_designer', Attributes.JEWELRY.jewelry_designer.friendly],
    ['jewelry_metal', Attributes.JEWELRY.jewelry_metal.friendly],
    ['jewelry_gemstones', Attributes.JEWELRY.jewelry_gemstones.friendly],
    ['jewelry_date_created', Attributes.JEWELRY.jewelry_date_created.friendly],
    ['jewelry_country_of_origin', Attributes.JEWELRY.jewelry_country_of_origin.friendly],
  ],

  TOY: [
    ['toy_type', Attributes.TOY.toy_type.friendly],
    ['toy_manufacturer', Attributes.TOY.toy_manufacturer.friendly],
    ['toy_series', Attributes.TOY.toy_series.friendly],
    ['toy_edition', Attributes.TOY.toy_edition.friendly],
    ['toy_dimensions', Attributes.TOY.toy_dimensions.friendly],
    ['toy_year_produced', Attributes.TOY.toy_year_produced.friendly],
    ['toy_country_of_origin', Attributes.TOY.toy_country_of_origin.friendly],
  ],

  STAMP: [
    ['s_country_of_origin', Attributes.STAMP.s_country_of_origin.friendly],
    ['s_category', Attributes.STAMP.s_category.friendly],
    ['s_denomination', Attributes.STAMP.s_denomination.friendly],
    ['s_series', Attributes.STAMP.s_series.friendly],
    ['s_color', Attributes.STAMP.s_color.friendly],
    ['s_year_produced', Attributes.STAMP.s_year_produced.friendly],
    ['s_engraved_by', Attributes.STAMP.s_engraved_by.friendly],
  ],

  COIN: [
    ['co_country_of_origin', Attributes.COIN.co_country_of_origin.friendly],
    ['co_denomination', Attributes.COIN.co_denomination.friendly],
    ['co_year', Attributes.COIN.co_year.friendly],
    ['co_composition', Attributes.COIN.co_composition.friendly],
    ['co_mintmark', Attributes.COIN.co_mintmark.friendly],
    ['co_mint', Attributes.COIN.co_mint.friendly],
    ['co_designer', Attributes.COIN.co_designer.friendly],
  ],

  SPORTS_CARD: [
    ['sports_card_type', Attributes.SPORTS_CARD.sports_card_type.friendly],
    ['sports_card_player', Attributes.SPORTS_CARD.sports_card_player.friendly],
    ['sports_card_team', Attributes.SPORTS_CARD.sports_card_team.friendly],
    ['sports_card_manufucturer', Attributes.SPORTS_CARD.sports_card_manufucturer.friendly],
    ['sports_card_set', Attributes.SPORTS_CARD.sports_card_set.friendly],
  ],

  VINYL_RECORD: [
    ['record_artist', Attributes.VINYL_RECORD.record_artist.friendly],
    ['record_artist', Attributes.VINYL_RECORD.record_musicians.friendly],
    ['record_year_released', Attributes.VINYL_RECORD.record_year_released.friendly],
    ['record_genre', Attributes.VINYL_RECORD.record_genre.friendly],
    ['record_label', Attributes.VINYL_RECORD.record_label.friendly],
  ],

  MUSICAL_MEM: [
    ['music_item_type', Attributes.MUSICAL_MEM.music_item_type.friendly],
    ['music_band', Attributes.MUSICAL_MEM.music_band.friendly],
    ['music_genre', Attributes.MUSICAL_MEM.music_genre.friendly],
    ['music_year', Attributes.MUSICAL_MEM.music_year.friendly],
    ['music_country', Attributes.MUSICAL_MEM.music_country.friendly],
  ],

  SPORTS_MEM: [
    ['sport_item_type', Attributes.SPORTS_MEM.sport_item_type.friendly],
    ['sport_type', Attributes.SPORTS_MEM.sport_type.friendly],
    ['sport_team', Attributes.SPORTS_MEM.sport_team.friendly],
    ['sport_player', Attributes.SPORTS_MEM.sport_player.friendly],
    ['sport_year', Attributes.SPORTS_MEM.sport_year.friendly],
    ['sport_country', Attributes.SPORTS_MEM.sport_country.friendly],
  ],

  HISTORIC_MEM: [
    ['hist_item_type', Attributes.HISTORIC_MEM.hist_item_type.friendly],
    ['hist_war', Attributes.HISTORIC_MEM.hist_war.friendly],
    ['hist_country', Attributes.HISTORIC_MEM.hist_country.friendly],
    ['hist_branch', Attributes.HISTORIC_MEM.hist_branch.friendly],
    ['hist_divison', Attributes.HISTORIC_MEM.hist_divison.friendly],
    ['hist_period', Attributes.HISTORIC_MEM.hist_period.friendly],
  ],

  MOVIE_MEM: [
    ['movie_item_type', Attributes.MOVIE_MEM.movie_item_type.friendly],
    ['movie_name', Attributes.MOVIE_MEM.movie_name.friendly],
    ['movie_celeb', Attributes.MOVIE_MEM.movie_celeb.friendly],
    ['movie_year', Attributes.MOVIE_MEM.movie_year.friendly],
    ['movie_genre', Attributes.MOVIE_MEM.movie_genre.friendly],
    ['movie_studio', Attributes.MOVIE_MEM.movie_studio.friendly],
  ],

  MUSICAL_INST: [
    ['inst_type', Attributes.MUSICAL_INST.inst_type.friendly],
    ['inst_brand', Attributes.MUSICAL_INST.inst_brand.friendly],
    ['inst_model', Attributes.MUSICAL_INST.inst_model.friendly],
    ['inst_year', Attributes.MUSICAL_INST.inst_year.friendly],
    ['inst_country', Attributes.MUSICAL_INST.inst_country.friendly],
  ],

  WINE: [
    ['wine_blend', Attributes.WINE.wine_blend.friendly],
    ['wine_producer', Attributes.WINE.wine_producer.friendly],
    ['wine_year', Attributes.WINE.wine_year.friendly],
    ['wine_region', Attributes.WINE.wine_region.friendly],
    ['wine_country', Attributes.WINE.wine_country.friendly],
  ],
};

export function getPossibleSplitAttrs(type) {
  if (PossibleSplitAttrs[type]) {
    return PossibleSplitAttrs[type];
  }

  return PossibleSplitAttrs.OTHER;
}



// WEBPACK FOOTER //
// ./src/config/dataAttributesIndex.js